import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { passwordActions } from './password.actions';
import { map, switchMap } from 'rxjs';
import { AuthService } from '../../../core/services/auth.service';

@Injectable()
export class PasswordEffects {
  constructor(private actions$: Actions, private authService: AuthService) {}

  recoverPasswordStart$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(passwordActions.recover_password_request_start),
        switchMap(data => {
          return this.authService.sendPasswordRecoverEmail(data.email).pipe(
            map(success => {
              return success ? passwordActions.recover_password_request_success() : passwordActions.recover_password_request_failure();
            })
          );
        })
      ),
    { dispatch: true }
  );

  resetPasswordStart$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(passwordActions.reset_password_request_start),
        switchMap(data => {
          return this.authService.resetPassword(data.email, data.password, data.token).pipe(
            map(success => {
              return success ? passwordActions.reset_password_request_success() : passwordActions.reset_password_request_failure();
            })
          );
        })
      ),
    { dispatch: true }
  );
}
